import { Button, ButtonProps } from 'antd';
import styled from 'styled-components';

export const StyledButton: React.FC<ButtonProps> = styled(Button)`
  min-width: 130px;
`;
